<template>
    <div class="global-patent-databases-wrapper">
        <div class="global-patent-databases-weekly-Updates-wrapper">
            <RowsExplain :title="$t('dataCoverage.globalPatentDatabases.weeklyUpdates')"/>
            <div id="global-patent-databases-weekly-Updates">
                <PtIcon icon="SolidLoadingBars" v-if="isWeekLoading"/>
            </div>
        </div>
        <div class="global-patent-databases-table-wrapper">
            <RowsExplain :title="$t('dataCoverage.nav.globalPatentDatabases')"/>
            <PtIcon icon="SolidLoadingBars" v-if="isLoading"/>
            <table class="global-patent-databases-table" v-if="tableData.length>0">
                <thead>
                <tr>
                    <th v-for="(item,index) in columnList" :style="{width:item.width+'px'}" :key="index" :class="{'common-tips':item.field==='commonTips'}">
                        <template v-if="item.field==='commonTips'">
                            <ElTooltip
                                effect="light"
                                placement="left"
                                :visible-arrow="false"
                                :enterable="false"
                                popper-class="global-patent-databases-table-tips"
                            >
                                <template slot="content">
                                    <div>
                                        <div class="citation-tips-item">
                                            <PtIcon icon="SolidDataHighCoverage"/>
                                            {{ $t('dataCoverage.globalPatentDatabases.citationTips1') }}
                                        </div>
                                        <div class="citation-tips-item">
                                            <PtIcon icon="SolidDataLowCoverage"/>
                                            {{ $t('dataCoverage.globalPatentDatabases.citationTips2') }}
                                        </div>
                                        <div class="citation-tips-item">
                                            {{ $t('dataCoverage.globalPatentDatabases.citationTips3Before') }}
                                            <PtIcon icon="SolidDataHighCoverage"/>
                                            {{ $t('dataCoverage.globalPatentDatabases.citationTips3After') }}
                                        </div>
                                    </div>
                                </template>
                                <PtIcon icon="SolidInfo"/>
                            </ElTooltip>
                        </template>
                        <template v-else>
                            {{item.title}}
                            <template v-if="item.statistics">{{$t('symbol.bracket.before')}}{{item.statisticsCount}}{{$t('symbol.bracket.after')}}</template>
                            <ElTooltip
                                v-if="item.field==='family'"
                                effect="light"
                                placement="left"
                                :enterable="false"
                                :visible-arrow="false"
                                popper-class="global-patent-databases-table-tips"
                            >
                                <template slot="content">
                                    <div>
                                        {{ $t('dataCoverage.globalPatentDatabases.familyTips') }}
                                    </div>
                                </template>
                                <PtIcon icon="SolidInfo"/>
                            </ElTooltip>
                            <ElTooltip
                                v-if="item.field==='fulltext'"
                                effect="light"
                                placement="left"
                                :enterable="false"
                                :visible-arrow="false"
                                popper-class="global-patent-databases-table-tips"
                            >
                                <template slot="content">
                                    <div>
                                        {{ $t('dataCoverage.globalPatentDatabases.fulltextTips') }}
                                    </div>
                                </template>
                                <PtIcon icon="SolidInfo"/>
                            </ElTooltip>
                        </template>
                    </th>
                </tr>
                </thead>
                <tbody v-for="(item, index) in tableData" :key="index">
                <tr :class="{'row--stripe': item.isStripe}">
                    <td :rowspan="item.status.length">{{index + 1}}</td>
                    <td :rowspan="item.status.length">
                        <Country :country="item.country"/>
                    </td>
                    <td>
                        <div class="patents_coverage-wrapper">
                            <div class="patents_type">{{ item.status[0].patent_type_desc }}</div>
                            <div class="patents_time-wrapper">
                                <div class="patents_from_time">
                                    {{ $t('page.status["From-address"]') }}{{$t('symbol.colon')}}{{ item.status[0].formDate }}
                                    <ElTooltip
                                        v-if="item.status[0].formDateTips"
                                        effect="light"
                                        placement="right"
                                        :visible-arrow="false"
                                        :enterable="false"
                                        popper-class="global-patent-databases-table-tips"
                                    >
                                        <template slot="content">
                                            <div v-html="item.status[0].formDateTips"></div>
                                        </template>
                                        <PtIcon icon="SolidInfo"/>
                                    </ElTooltip>
                                </div>
                                <div class="patents_update_time">
                                    {{ $t('page.status["To-address"]') }}{{$t('symbol.colon')}}{{item.status[0].last_update}}
                                </div>
                            </div>
                        </div>
                    </td>

                    <td>
                        <Status :count="item.status[0].biblio"/>
                    </td>
                    <td>
                        <Status :count="item.status[0].fulltext"/>
                    </td>
                    <td>
                        <Status :count="item.status[0].pdf"/>
                    </td>
                    <td>
                        <Status :count="item.status[0].image"/>
                    </td>
                    <td>
                        <Status :count="item.status[0].legal"/>
                    </td>
                    <td>
                        <Status :count="item.status[0].family"/>
                    </td>
                    <td>
                        <Status :count="item.status[0].citation"/>
                    </td>
                    <td/>
                </tr>
                <template v-for="(subItem, subIndex) in item.status" >
                    <tr :key="subIndex" v-if="subIndex!==0" :class="{'row--stripe': subItem.isStripe}">
                    <td>
                        <div class="patents_coverage-wrapper">
                            <div class="patents_type">{{ subItem.patent_type_desc }}</div>
                            <div class="patents_time-wrapper">
                                <div class="patents_from_time">
                                    {{ $t('page.status["From-address"]') }}{{$t('symbol.colon')}}{{ subItem.formDate }}
                                    <ElTooltip
                                        v-if="subItem.formDateTips"
                                        effect="light"
                                        placement="right"
                                        :visible-arrow="false"
                                        :enterable="false"
                                        popper-class="global-patent-databases-table-tips"
                                    >
                                        <template slot="content">
                                            <div v-html="subItem.formDateTips"></div>
                                        </template>
                                        <PtIcon icon="SolidInfo"/>
                                    </ElTooltip>
                                </div>
                                <div class="patents_update_time">
                                    {{ $t('page.status["To-address"]') }}{{$t('symbol.colon')}}{{ subItem.last_update}}
                                </div>
                            </div>
                        </div>
                    </td>

                    <td>
                        <Status :count="subItem.biblio"/>
                    </td>
                    <td>
                        <Status :count="subItem.fulltext"/>
                    </td>
                    <td>
                        <Status :count="subItem.pdf"/>
                    </td>
                    <td>
                        <Status :count="subItem.image"/>
                    </td>
                    <td>
                        <Status :count="subItem.legal"/>
                    </td>
                    <td>
                        <Status :count="subItem.family"/>
                    </td>
                    <td>
                        <Status :count="subItem.citation"/>
                    </td>
                    <td/>
                </tr>
                </template>
                </tbody>
            </table>
            <div class="global-patent-databases-desc">
                {{ $t('page.status.dataSource') }}
                <a :href="officialLinks" target="_blank"> © European Patent Organisation</a>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon as PtIcon } from 'patsnap-biz';
import { Tooltip } from 'element-ui';
import { get, find, template, isEmpty } from 'lodash';
import RowsExplain from '../../../components/rows-explain/RowsExplain';
import Country from '../../../components/Country/Country';
import Status from '../../../components/Status/Status';
import { Site, SLD } from '@patsnap-utils/biz';
import {
    fetchPatentWeekData,
    getStatusApi
} from '../../../../../../../../../components/apis/core_basic_api/data_coverage';
import { getStatusTabCount } from '../../../util';
import formatNumber from '../../../../../utils/formatNumber';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

export default {
    name: 'GlobalPatentDatabases',
    components: {
        RowsExplain,
        PtIcon,
        Country,
        Status,
        ElTooltip: Tooltip,
    },
    props: {
        officialLinks: {
            type: String,
        }
    },
    data() {
        return {
            isLoading: true,
            isWeekLoading: true,
            weeklyUpdateList: [],
            tableData: [],
            mergeCells: [],
            columnList: [
                { field: 'id', title: '#', width: 50 },
                { field: 'country', title: this.$t('dataCoverage.authority') },
                {
                    field: 'patentsCoverage',
                    title: this.$t('dataCoverage.globalPatentDatabases.patentsCoverage'),
                    width: 180
                },
                {
                    field: 'biblio',
                    title: this.$t('dataCoverage.globalPatentDatabases.bibliography'),
                    width: 120,
                    statistics: true
                },
                { field: 'fulltext', title: this.$t('dataCoverage.globalPatentDatabases.fulltext'), width: 100, statistics: true },
                { field: 'pdf', title: this.$t('page.status["PDF"]'), width: 100, statistics: true },
                {
                    field: 'image',
                    title: this.$t('dataCoverage.globalPatentDatabases.image'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'legal',
                    title: this.$t('dataCoverage.globalPatentDatabases.legalStatus'),
                    width: 120,
                    statistics: true
                },
                {
                    field: 'family',
                    title: this.$t('dataCoverage.globalPatentDatabases.family'),
                    width: 150,
                    statistics: true
                },
                {
                    field: 'citation',
                    title: this.$t('dataCoverage.globalPatentDatabases.citation'),
                    width: 90,
                    statistics: true
                },
                {
                    field: 'commonTips',
                    width: 42,
                },
            ],
            currentLang: this.$i18n.locale,
        };
    },
    methods: {
        transFromDate(item) {
            let str = `\${${item.type}} ${item.from_format}`;
            if (item.type !== 'from') {
                if (this.currentLang === 'jp') {
                    str = `${this.$t('symbol.bracket.before')}${str} \${jp_from}${this.$t('symbol.bracket.after')}`;
                } else {
                    str = `${this.$t('symbol.bracket.before')}${str}${this.$t('symbol.bracket.after')}`;
                }
            }
            return this.translateFromData(str);
        },
        translateFromData(formData) {
            if (this.currentLang === 'jp') {
                return template(formData)({
                    from: '',
                    pdf: this.$t('page.status["jp PDF"]'),
                    jp_from: this.$t('page.status["jp from"]'),
                    pdf_available: this.$t('page.status["PDF is available for granted patents, from"]'),
                    fulltext: this.$t('page.status["jp Fulltext"]'),
                    pdf_fulltext: this.$t('page.status["jp Fulltext and PDF"]')
                });
            }
            return template(formData)({
                from: '',
                pdf: this.$t('page.status["PDF from"]'),
                pdf_available: this.$t('page.status["PDF is available for granted patents, from"]'),
                fulltext: this.$t('page.status["Fulltext from"]'),
                pdf_fulltext: this.$t('page.status["Fulltext and PDF from"]')
            });
        },
        async init() {
            try {
                this.isWeekLoading = true;
                let res = await fetchPatentWeekData();
                this.weeklyUpdateList = res;
                this.draw();
            } catch (e) {
                console.log(e);
            } finally {
                this.isWeekLoading = false;
            }
        },
        draw() {
            this.$nextTick(() => {
                var myChart = this.$echarts.init(document.getElementById('global-patent-databases-weekly-Updates'));
                const options = {
                    grid: {
                        // top: 20,
                        left: 0,
                        right: 0,
                        // bottom: 20
                    },
                    legend: {
                        show: false,
                    },
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#D8F4C7' // 0% 处的颜色
                        }, {
                            offset: 1, color: '#EDFAFB' // 100% 处的颜色
                        }],
                        global: false
                    },
                    tooltip: {
                        show: false,
                    },
                    dataset: {
                        dimensions: ['week', 'update_count'],
                        source: this.weeklyUpdateList
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        }
                    },
                    yAxis: {
                        show: false,
                    },
                    series: [
                        {
                            type: 'bar',
                            barMinHeight: 10,
                            emphasis: {
                                animation: false,
                                label: {
                                    show: true,
                                    fontSize: 11,
                                    position: 'top',
                                    color: '#000000',
                                    distance: 0,
                                    formatter: (data) => {
                                        return formatNumber(get(data, 'value.update_count', 0));
                                    }
                                },
                                itemStyle: {
                                    color: '#45A321'
                                }
                            }
                        },
                    ]
                };
                myChart.setOption(options);
                myChart.on('click', ({ data }) => {
                    window.open(new Site({
                        sld: SLD.ANALYTICS,
                        pathname: `search/result?q=PBD:[${data.start_time} TO ${data.end_time}]`,
                    }).href);
                });
            });
        },
        // 数据格式化
        transCountryData(data) {
            let transData = [];
            if (data.length) {
                let countryList = {};
                data.forEach(val => {
                    val.patent_type = val.patent_type.slice(-1);
                    val.patent_type_desc = (val.country === 'EP' && val.patent_type === 'D') ? this.$t('page.status.OHIM') : this.$t(`page.status['${val.patent_type}']`);
                    val.formDateTips = '';
                    (val.start_remark || []).forEach(remark => {
                        if (remark.type !== 'from') {
                            val.formDateTips += `${val.formDateTips === '' ? '' : '</br>'}${this.transFromDate(remark)}`;
                        }
                    });

                    val.formDate = get(find(val.start_remark, { 'type': 'from' }), 'from_format', '');

                    // 生成countryList
                    if (countryList[val.country]) {
                        countryList[val.country].status.push({
                            patent_type: val.patent_type,
                            start_remark: val.start_remark,
                            patent_type_desc: val.patent_type_desc,
                            formDate: val.formDate,
                            formDateTips: val.formDateTips,
                            last_update: val.last_update_format,
                            ...val.coverage_status
                        });
                    } else {
                        countryList[val.country] = {};
                        countryList[val.country].country = val.country;
                        countryList[val.country].status = [
                            {
                                patent_type: val.patent_type,
                                start_remark: val.start_remark,
                                formDate: val.formDate,
                                formDateTips: val.formDateTips,
                                patent_type_desc: val.patent_type_desc,
                                last_update: val.last_update_format,
                                ...val.coverage_status
                            }
                        ];
                    }
                });
                // 拼装数组
                let i = 0;
                if (!isEmpty(countryList)) {
                    for (var key in countryList) {
                        countryList[key].isStripe = i % 2 === 1;
                        countryList[key].status.forEach(item=> item.isStripe = i % 2 === 1);
                        i++;
                        transData.push(countryList[key]);
                    }
                }
            }
            // 对专利类型排序
            if (transData.length) {
                transData.forEach(item => {
                    if (item.status && item.status.length > 1) {
                        let temp = ['A', 'B', 'U', 'D'];
                        item.status.sort((a, b) => {
                            return temp.indexOf(a.patent_type) - temp.indexOf(b.patent_type);
                        });
                    }
                });
            }
            return transData;
        },
        async getStatus() {
            try {
                this.isLoading = true;
                let res = await getStatusApi();
                this.tableData = this.transCountryData(get(res, 'dataCoverage.allDb', []));
                this.columnList.forEach(item=>{
                    if (item.statistics) {
                        item.statisticsCount = getStatusTabCount(this.tableData, item.field, 'global');
                    }
                });
            } finally {
                this.isLoading = false;
            }
        }
    },
    created() {
        this.init();
        this.getStatus();
    }
};
</script>

<style lang="scss">
.global-patent-databases-wrapper {
    background: $bg-white;
    width: 1280px;
    margin: 0 auto;
    padding: 0 36px 36px;
    box-sizing: border-box;
    z-index: 20;

    .global-patent-databases-weekly-Updates-wrapper {
        background: $bg-white;
        width: 100%;
        position: sticky;
        top: 106px;
        z-index: 20;
        padding-bottom: 16px;

        #global-patent-databases-weekly-Updates {
            width: 1178px;
            height: 88px;
            margin: 0 auto;
        }

        .rows-explain-wrapper {
            margin-top: 0;
        }
    }

    .global-patent-databases-table-wrapper {
        padding: 0 0 8px;

        .rows-explain-wrapper {
            margin-top: 0;
            position: sticky;
            top: 234px;
            z-index: 20;
            padding-bottom: 8px;
        }

        .global-patent-databases-table {
            thead{
                position: sticky;
                top: 264px;
                z-index: 20;
            }
            .patents_coverage-wrapper {
                .patents_type {
                    font-size: 14px;
                    font-weight: 400;
                    color: #061632;
                    line-height: 20px;
                }

                .patents_time-wrapper {
                    font-size: 12px;
                    font-weight: 400;
                    color: $text-hint;
                    line-height: 16px;
                }

                .patsnap-biz-icon {
                    margin: 0;
                }
            }
        }

        .global-patent-databases-desc {
            margin-top: 16px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #061632;
            line-height: 20px;
            text-align: right;

            a {
                color: $green-primary;
            }
        }
    }

    .patsnap-biz-icon {
        &[icon="SolidLoadingBars"] {
            fill: $fill-normal !important;
            font-size: 48px;
            display: block;
            margin: 0 auto;
        }
    }
}
.el-tooltip__popper {
    &.global-patent-databases-table-tips {
        &.is-light {
            margin-left: 4px !important;
            padding: 8px 12px;
            background: $bg-white;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
            border-radius: 4px;
            line-height: 16px;
            color: $text-secondary;
            font-size: 12px;
            border: 1px solid $border-light;
            max-width: 520px;

            .patsnap-biz-icon {
                font-size: 24px;
                fill: $green-primary;
                margin-bottom: 0;
            }
            .citation-tips-item{
                display: flex;
                align-items: center;
            }
        }
    }
}
</style>
